// src/redux/constants.js

export const SET_THUMBNAILS = 'SET_THUMBNAILS';
export const CLEAR_THUMBNAILS = 'CLEAR_THUMBNAILS';
